module.exports = __webpack_public_path__ + "img/radiografia2.a782a3ef.jpg";